<template>
    <organisation-switcher class="ml-3" />
    <v-spacer></v-spacer>
    <div class="user-container mr-3">
        <!-- user logo -->
        <v-img class="user-logo" :src="userPicture"></v-img>
        <!-- user details -->
        <div class="user-details-container">
            <div data-cy="userName" class="user-name body-small white-text">
                {{ userName }}
            </div>
        </div>
        <!-- settings button -->
        <div class="settings-container">
            <v-menu>
                <template #activator="{ props }">
                    <icon-button
                        data-cy="userMenuButton"
                        btn-style="default-btn medium-icon-btn transparent-btn"
                        :icon="mdiDotsHorizontal"
                        v-bind="props"
                    />
                </template>
                <v-list class="user-menu" data-cy="userMenu">
                    <v-list-item
                        data-cy="menuSettingsButton"
                        class="user-menu-item"
                        :disabled="!pStore.areContractsSigned"
                        @click="
                            pStore.areContractsSigned &&
                            changeRoute(
                                '/organisation/settings/account-information',
                            )
                        "
                    >
                        <template #prepend>
                            <v-icon :icon="mdiCog" />
                        </template>
                        <v-list-item-title class="mr-2 body-medium white-text">
                            Settings
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        data-cy="menuLogoutButton"
                        class="user-menu-item"
                        @click="handleLogout()"
                    >
                        <template #prepend>
                            <v-icon :icon="mdiLogout" />
                        </template>
                        <v-list-item-title class="mr-2 body-medium white-text">
                            Logout
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { signOut } from "aws-amplify/auth";
import { useRouter } from "vue-router";
import { usePiniaStore } from "@/stores/store";
import { useOrganisationStore } from "@/stores/organisationStore";

import iconButton from "@/components/buttons/iconButton.vue";
import OrganisationSwitcher from "@/components/structural/OrganisationSwitcher.vue";

import { redirectToRoute } from "@/router";
import { AuthRouteNames } from "@/constants/routes";
import { getEmailFromCurrentSession } from "@/cognito-auth/sessionManagement";
import { mdiCog, mdiDotsHorizontal, mdiLogout } from "@mdi/js";

const router = useRouter();
const pStore = usePiniaStore();
const organisationStore = useOrganisationStore();

// get user details
const userPicture = computed(() => "");
const userName = computed(() => pStore.getUserEmail ?? "");

const changeRoute = (path: string) => {
    router.push(path).catch((err) => {
        console.log("Route error: " + err);
    });
};

// logs user out
const handleLogout = async () => {
    pStore.setIsAuthenticated(false);

    try {
        await signOut({ global: true });
    } finally {
        organisationStore.clearOrganisationContext(pStore.getUserEmail);
        redirectToRoute({ name: AuthRouteNames.LOGIN });
    }
};

onMounted(async () => {
    if (!pStore.getUserEmail) {
        const email = await getEmailFromCurrentSession();
        pStore.setUserEmail(email ?? "");
    }
});
</script>
